<script>
import store from '../store';

export default {
  methods: {
    $ownerFile(file, uri) {
      let userId = store.getters['auth/user'].id;

      if (uri.includes('/form/neopass/')) {
        userId = parseInt(uri.split('/form/neopass/')[1].split('/')[0]);
      }

      // owner can edit
      if (file.author_id === userId) {
        return true;
      }
    },

    $adminFile(file, uri) {
      if (!file.users && !file.roles) {
        return false;
      }

      let userId = store.getters['auth/user'].id;

      if (uri.includes('/form/neopass/')) {
        userId = parseInt(uri.split('/form/neopass/')[1].split('/')[0]);
      }

      if (this.$ownerFile(file, uri)) {
        return true;
      }

      if (file.users.filter((u) => u.id === userId).length === 0) {
        let role = store.getters['auth/role'];

        if (file.roles.filter((r) => r.name === role).length > 0) {
          let rights = file.roles.filter((r) => r.name === role)[0].pivot.role;

          return rights == 'admin';
        }

        return false;
      }

      let rights = file.users.filter((u) => u.id === userId)[0].pivot.role;

      return rights == 'admin';
    },

    $editFile(file, uri) {
      if (!file.users) {
        return false;
      }

      let userId = store.getters['auth/user'].id;

      if (uri.includes('/form/neopass/')) {
        userId = parseInt(uri.split('/form/neopass/')[1].split('/')[0]);
      }

      if (this.$ownerFile(file, uri)) {
        return true;
      }

      // Not a shared file
      if (file.users.filter((u) => u.id === userId).length === 0) {
        let role = store.getters['auth/role'];

        if (file.roles.filter((r) => r.name === role).length > 0) {
          let rights = file.roles.filter((r) => r.name === role)[0].pivot.role;

          return rights == 'admin' || rights == 'edit';
        }

        return false;
      }

      let rights = file.users.filter((u) => u.id === userId)[0].pivot.role;

      return rights == 'admin' || rights == 'edit';
    },

    $readFile(file, uri) {
      //method to verify permissions on user
      if (!file.users) {
        return false;
      }

      let userId = store.getters['auth/user'].id;

      if (uri.includes('/form/neopass/')) {
        userId = parseInt(uri.split('/form/neopass/')[1].split('/')[0]);
      }

      if (this.$ownerFile(file, uri)) {
        return true;
      }

      if (file.users.filter((u) => u.id === userId).length === 0) {
        let role = store.getters['auth/role'];

        if (file.roles.filter((r) => r.name === role).length > 0) {
          let rights = file.roles.filter((r) => r.name === role)[0].pivot.role;

          return rights == 'admin' || rights == 'edit' || rights == 'read';
        }

        return false;
      }

      let rights = file.users.filter((u) => u.id === userId)[0].pivot.role;

      return rights == 'admin' || rights == 'edit' || rights == 'read';
    },
  },
};
</script>
